import { View } from "@react-pdf/renderer";
import SpecieYOYRow from "../TotalTable/SpecieYOYRow";
import SpecieYOYHeader from "../TotalTable/SpecieYOYHeader";

const SpecieYOYTable = (props) => {
  return (
    <View style={{ marginTop: 30 }}>
      <SpecieYOYHeader styles={props.styles} name={props.name} />
      <SpecieYOYRow items={props.data} />
    </View>
  );
};
export default SpecieYOYTable;
